export default __webpack_public_path__ + "static/media/ztbk_w.a3eefa66.png";